module.exports = __webpack_public_path__ + "static/img/draft_flow copy.d287c7c9.jpg";